import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import { fetchChangelog } from '../services/actions';
import { selectChangelog } from '../services/selectors';

export const useChangelog = () => {
    const content = useAppSelector(selectChangelog);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchChangelog());
    }, [dispatch]);

    return content;
};
